import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

function smoothScrollTo(id) {
  const el = document.getElementById(id);
  if (!el) return;
  const top = el.getBoundingClientRect().top + window.scrollY - 80;
  window.scrollTo({ top, behavior: "smooth" });
}

// ── Link data ──────────────────────────────────────────────────────────────
// scroll: string → smooth-scroll to that section id (same-page)
// route: string  → React Router Link (SPA navigation) — real, crawlable URLs
const COLS = [
  {
    heading: "Product",
    links: [
      { label: "Features", scroll: "features" },
      { label: "Pricing",  scroll: "pricing"  },
      { label: "Security", scroll: "features" },
      { label: "API",      route:  "/docs"    },
    ],
  },
  {
    heading: "Company",
    links: [
      { label: "About",   route: "/about"   },
      { label: "Blog",    route: "/blog"    },
      { label: "Careers", route: "/careers" },
      { label: "Press",   route: "/press"   },
    ],
  },
  {
    heading: "Support",
    links: [
      { label: "Help Center", route: "/support#help"      },
      { label: "Contact",     route: "/support#contact"   },
      { label: "Status",      route: "/support#status"    },
      { label: "Community",   route: "/support#community" },
    ],
  },
  {
    heading: "Legal",
    links: [
      { label: "Privacy",        route: "/legal/privacy" },
      { label: "Terms",          route: "/legal/terms" },
      { label: "Refund policy",  route: "/legal/refund" },
      { label: "Cookies",        route: "/legal/cookies" },
      { label: "Delete account", route: "/legal/delete-account" },
    ],
  },
];

// ── Link renderer ──────────────────────────────────────────────────────────
const linkStyle = { color: "rgba(255,255,255,0.36)", transition: "color 0.18s" };
const linkHover = {
  onMouseEnter: (e) => { e.currentTarget.style.color = "rgba(255,255,255,0.72)"; },
  onMouseLeave: (e) => { e.currentTarget.style.color = "rgba(255,255,255,0.36)"; },
};

// ── Footer ─────────────────────────────────────────────────────────────────
export default function Footer() {
  return (
    <>
      <footer style={{ background: "var(--color-footer-bg)", borderTop: "1px solid rgba(255,255,255,0.05)" }}>
        <div className="max-w-[1200px] mx-auto px-6 py-16">
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-8 mb-14">

            {/* Brand column */}
            <div className="col-span-2 sm:col-span-3 lg:col-span-1">
              <Logo variant="dark" size="sm" />
              <p
                className="text-[13px] leading-relaxed mt-4 mb-6 max-w-[220px]"
                style={{ color: "rgba(255,255,255,0.36)" }}
              >
                The global diaspora deserves financial infrastructure that reflects their dignity.
              </p>
            </div>

            {/* Nav columns */}
            {COLS.map((col) => (
              <div key={col.heading}>
                <p
                  className="text-[10px] font-bold uppercase tracking-[0.2em] mb-4"
                  style={{ color: "rgba(255,255,255,0.26)" }}
                >
                  {col.heading}
                </p>
                <ul className="space-y-3">
                  {col.links.map((link) => (
                    <li key={link.label}>
                      {link.scroll ? (
                        <button
                          onClick={() => smoothScrollTo(link.scroll)}
                          className="text-[13px] transition-colors"
                          style={{ ...linkStyle, background: "none", border: "none", cursor: "pointer", padding: 0 }}
                          {...linkHover}
                        >
                          {link.label}
                        </button>
                      ) : (
                        <Link
                          to={link.route}
                          className="text-[13px] transition-colors"
                          style={linkStyle}
                          {...linkHover}
                        >
                          {link.label}
                        </Link>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Bottom bar */}
          <div
            className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 pt-8"
            style={{ borderTop: "1px solid rgba(255,255,255,0.06)" }}
          >
            <p className="text-[12px]" style={{ color: "rgba(255,255,255,0.22)" }}>
              © 2025 Mikkshebs System Technology S.R.L.
            </p>
            <div className="flex flex-wrap gap-x-6 gap-y-1">
              {[
                { label: "Privacy", route: "/legal/privacy" },
                { label: "Terms",   route: "/legal/terms" },
                { label: "Cookies", route: "/legal/cookies" },
              ].map((l) => (
                <Link
                  key={l.label}
                  to={l.route}
                  className="text-[12px] transition-colors"
                  style={{ color: "rgba(255,255,255,0.22)" }}
                  onMouseEnter={(e) => { e.currentTarget.style.color = "rgba(255,255,255,0.55)"; }}
                  onMouseLeave={(e) => { e.currentTarget.style.color = "rgba(255,255,255,0.22)"; }}
                >
                  {l.label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
